import { render, staticRenderFns } from "./addMatch.vue?vue&type=template&id=7e143d8a&scoped=true&"
import script from "./addMatch.vue?vue&type=script&lang=js&"
export * from "./addMatch.vue?vue&type=script&lang=js&"
import style0 from "./addMatch.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./addMatch.vue?vue&type=style&index=1&id=7e143d8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e143d8a",
  null
  
)

export default component.exports